const UNIQUE_VARIANT_IDS = new Set([
  '67610142605364',
  '67610142638132',
  '67610142670900',
  '67610142703668',
  '67610142736436',
  '67610142769204',
  '67610143195188',
  '67610143227956',
  '67610143260724',
  '67610143293492',
  '67610143326260',
  '67610143359028',
]);

const COMPONENT_SELECTOR =
  'quantity-selector-component[data-variant-id], cart-quantity-selector-component[data-variant-id]';

function variantIdOf(component) {
  return String(component?.dataset?.variantId || '').split('/').pop();
}

function enforceUniqueQuantity(component) {
  if (!(component instanceof HTMLElement) || !UNIQUE_VARIANT_IDS.has(variantIdOf(component))) return;

  component.dataset.morrugoUnique = 'true';
  const input = component.querySelector('input[ref="quantityInput"]');
  const plusButton = component.querySelector('[ref="plusButton"]');
  if (!(input instanceof HTMLInputElement)) return;

  input.max = '1';
  input.step = '1';

  const previousValue = Number.parseInt(input.value || '1', 10);
  const needsCorrection = Number.isFinite(previousValue) && previousValue > 1;

  if (needsCorrection) {
    input.value = '1';
    input.removeAttribute('data-skip-value-update');
  }

  if (plusButton instanceof HTMLButtonElement) plusButton.disabled = true;

  if (typeof component.updateButtonStates === 'function') {
    component.updateButtonStates();
  }

  if (component.dataset.morrugoUniqueBound !== 'true') {
    component.dataset.morrugoUniqueBound = 'true';
    input.addEventListener('input', () => {
      const value = Number.parseInt(input.value || '1', 10);
      if (Number.isFinite(value) && value > 1) input.value = '1';
    });
  }

  if (needsCorrection && component.tagName.toLowerCase() === 'cart-quantity-selector-component') {
    queueMicrotask(() => {
      if (typeof component.onQuantityChange === 'function') component.onQuantityChange();
    });
  }
}

function enforceAll(scope = document) {
  if (scope instanceof Element && scope.matches(COMPONENT_SELECTOR)) enforceUniqueQuantity(scope);
  if ('querySelectorAll' in scope) scope.querySelectorAll(COMPONENT_SELECTOR).forEach(enforceUniqueQuantity);
}

function startUniqueRugGuard() {
  enforceAll(document);

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) enforceAll(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  Promise.all([
    customElements.whenDefined('quantity-selector-component'),
    customElements.whenDefined('cart-quantity-selector-component'),
  ]).then(() => enforceAll(document));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startUniqueRugGuard, { once: true });
} else {
  startUniqueRugGuard();
}
